import { render, staticRenderFns } from "./hostinfo.vue?vue&type=template&id=3b7ccfb3&lang=pug"
import script from "./hostinfo.vue?vue&type=script&lang=js"
export * from "./hostinfo.vue?vue&type=script&lang=js"
import style0 from "./hostinfo.vue?vue&type=style&index=0&id=3b7ccfb3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports